import React from 'react';
import { Outlet, Navigate } from 'react-router-dom';

export function CommonRoutes() {
  const auth = localStorage.getItem('token');
  return  <Outlet />;
}

export function StepRoutes() {
    const auth = localStorage.getItem('token');
    return <Outlet />;
  }

  // eslint-disable-next-line import/no-anonymous-default-export
  export default { StepRoutes, CommonRoutes };